export const apiConstants = {
  url: "/api/frame"
};
